import styled, { css } from 'styled-components';
import {BLACK_200, BLACK_300, GREY_12, GREY_4, WHITE} from '../../utils/colors';
import device from '../../utils/mediaQuery';

export const TitleWrapper = styled.div`
  margin-bottom: 20px;
  
  svg {
    path {
        fill: ${BLACK_300} !important;
    }
  }
`;

export const ProgressIcon = styled.div<{ road?: boolean }>`
  svg {
    margin-left: -2px;
  }

  &:before {
    content: "";
    border: 1px solid ${GREY_12};
    position: absolute;
    left: 94px;
    bottom: 0;
    top: 25px;
  }
  
    ${({ road }) => road && css`
      &:before {
        top: 21px;
      }
      
      &:after {
        content: "";
        border: 1px solid ${GREY_12};
        position: absolute;
        left: 94px;
        top: 0;
        bottom: 39px;
      }
    `}
`;

export const RowItem = styled.div`
    display: flex;
    column-gap: 20px;
    padding-bottom: 15px;
    align-items: center;
    position: relative;
`;

export const CircleIcon = styled.div`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${WHITE};
    border: solid 1.5px ${BLACK_200};
`

export const TimeWrapper = styled.div`
    width: 70px;
`;

export const RoadDetailsWrapper = styled.div`
    flex: 1;
`;

export const RoadLogoWrapper = styled.span`
     img {
       height: 15px;
       margin-right: 4px
     }
`;

export const RoadDetailsContainer = styled.div`
  margin-bottom: 15px;
`;

export const RoadDetails = styled.div`
    position: relative;
    border: solid 1px ${GREY_4};
    padding: 12px;
    border-radius: 12px;
    background: ${WHITE};
  
    ${RowItem} {
      &:last-of-type {
        margin-bottom: 0;
        
        ${ProgressIcon} {
            &:before {
              top: 0;
              bottom: 40px;
            }
        }
      }
    }
`;

export const ContentWrapper = styled.div<{ showPriceBreakDown?: boolean }>`
  padding: 10px;
  overflow: visible;
  
  ${({ showPriceBreakDown }) => showPriceBreakDown && css`
    padding-bottom: 150px;
  `};

  @media ${device.large} {
    padding-bottom: 10px;
  }
`;

export const ActionWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: 24px 16px;
  border-top: 1px solid #EEEEEE;
  z-index: 100;

  @media ${device.large} {
    position: unset;
    border: none;
    padding-top: 10px;
  }
`;

export const ActionButtonWrapper = styled.div`
  flex: 1;
  
  @media(${device.large}) {
    margin-top: 15px;
  }
`;

export const ActionContentWrapper = styled.div`
  display: flex;
  column-gap: 40px;
  justify-content: space-between;
  align-items: flex-end;

  @media ${device.large} {
    display: block;
    margin: 30px 0 15px;
  }
`;

export const ActionContentLink = styled.div`
  margin-bottom: 30px;

  @media ${device.large} {
    margin-bottom: 0;
  }
`;
